import classes from './selectedContactComponent.scss';
import SetUpVoiceDropdown from './voiceDropDown';
import SetUpEmailDropdown from './emailDropdown';
import SetUpTextDropdown from './textDropdown';
import NotificationHelper from './notificationHelper';
import SceErrorBox from '../../../../Common/ErrorBox/sceErrorBox';
import SceTextBox from '../../../../Common/TextBox/sceText';
import { getLocalizedStrings } from "../../../centralizedLocalizedString";

class SelectedContactComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleDrawerStatus: false,
            addEmail: false,
            removeIcon:false,
            removeButtonPress:false,
            editButtonPress:false,
            doneButtonPress:false,
            isAddBtnDisabled:false,
            isSelected:true,
            isAddBox:false
        };
        this.strings = getLocalizedStrings('RepairMaintenanceAlerts');
        let editIcon;
        this.editIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/CTA_Edit_Small.svg';
        this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg';
        let emailIcon;
        let closeIcon;
        let addIcon;
        let removeIcon;
        this.removeIcon= drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Remove.svg';
        this.emailIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
        this.closeIcon=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg';
    }
    addButtonHandler(){
        const updatedState={...this.state};
        updatedState.isAddBtnDisabled=true;
        updatedState.isSelected=true;
        updatedState.isAddBox=false;
        this.setState(updatedState); 
    }
    removeIconHandler=()=>{
        const updatedState={...this.state};
        updatedState.removeButtonPress=true;
        updatedState.isSelected=false;
        this.setState(updatedState,()=>{
            this.props.onDoneEnabledButton(true);
        });
    }
    removeButtonHandler= () => 
    {
        const updatedState={...this.state};
        updatedState.addEmail=false;
        updatedState.removeIcon=false;
        updatedState.removeButtonPress=false;
        updatedState.editButtonPress=false;
        updatedState.doneButtonPress=false;
        updatedState.isAddBtnDisabled=false;
        updatedState.isSelected=true;
        updatedState.isAddBox=false;
        this.props.onDoneEnabledButton(false);
        this.setState(updatedState,()=>{
             this.props.onContactMethodCheckHandler(this.props.contactType,this.props.contactMethodIndex);
        });
      
    }
    removeCancelBtnHandler=()=>{
        const updatedState={...this.state};
        updatedState.removeButtonPress=false;
        updatedState.isSelected=true;
        this.setState(updatedState,()=>{
            this.props.onDoneEnabledButton(false);
        });

    }
    doneButtonHandler()
    {
        const updatedState={...this.state};
        updatedState.doneButtonPress=true;
        this.setState(updatedState);
        
    }
    cancelButtonHandler=()=>{
        const updatedState={...this.state};
        updatedState.removeButtonPress=false;
        updatedState.removeIcon=false;
        updatedState.editButtonPress=true;
        this.setState(updatedState);
    }
    onContactDrawerToggleHandler = () => {
        let updatedData = { ...this.state };
        updatedData.toggleDrawerStatus = !updatedData.toggleDrawerStatus;
        this.props.onDoneEnabledButton(updatedData.toggleDrawerStatus);
        this.setState(updatedData, () => { });
    }
    onSelectDropDown = (e, contactMethodIndex) => {
        this.onContactDrawerToggleHandler();
        this.props.onSelectDropDown(e, contactMethodIndex);
    }
    handleClick = (e) => this.setState({isAddClicked:true});
    render() {
        const contactType = this.props.contactType;
        const addContactValue = this.props.addContactValueArr[contactType];
        const addContactCheckedStatusArr = this.props.addContactCheckedStatusArr[contactType];
        const contactMethodIndex = this.props.contactMethodIndex;
        return (
            <div className={classes.selectedContactComponent} >
                {!this.state.toggleDrawerStatus ?
                    <div className='row'>
                        {(this.state.isAddBox)
                            ?<div>
                                <div className={classes.box}>
                                        <span className={classes.sceTextBox}>
                                            <SceTextBox 
                                                type="text" 
                                                defaultValue={contactType==="email"?NotificationHelper.formatEmailIdWithStar(addContactValue[contactMethodIndex]):NotificationHelper.formatPhoneNumWithStar(addContactValue[contactMethodIndex])}
                                            />
                                        </span>
                                        <span className={classes.addCancelButtonAlign}>
                                            <span className={classes.addButtonAlign}>
                                                <button className={this.state.isAddBtnDisabled ? classes.AddDisabledButton : classes.AddButton} onClick={this.addButtonHandler.bind(this)}>
                                                {this.strings.addBtnName}
                                                </button>
                                            </span>
                                            <span className={classes.EditButtonAlign}>
                                                <button className={classes.CancelButton} 
                                                onClick={this.cancelButtonHandler.bind(this)}>{this.strings.cancelButton}</button>
                                            </span>
                                        </span>

                                    </div>
                            </div>:null}
                            {(this.state.isSelected)?
                                    <span>
                                    <button className={classes.sceOutgDeleteicon} onClick={this.removeIconHandler.bind(this)} > <img src={this.removeIcon} alt="Remove Icon" /> </button>    
                                        <span className={classes.emailData}>{contactType==="email"?NotificationHelper.formatEmailIdWithStar(addContactValue[contactMethodIndex]):NotificationHelper.formatPhoneNumWithStar(addContactValue[contactMethodIndex])}</span>
                                            <span className={classes.editButtonAlign}>
                                                <button className={classes.EditButton} onClick={() => this.onContactDrawerToggleHandler()} >{this.strings.editButton}</button>
                                            </span>
                                         <div className={classes.dividerLine} />
                                    </span>:null}
                           {(this.state.removeButtonPress)?
                             <span>
                                <span className={classes.emailData}>{contactType==="email"?NotificationHelper.formatEmailIdWithStar(addContactValue[contactMethodIndex]):NotificationHelper.formatPhoneNumWithStar(addContactValue[contactMethodIndex])}</span>
                                    <span className={classes.buttonAlign}>
                                        <span className={classes.removeButtonAlign}>
                                        <button className={classes.RemoveButton} onClick={this.removeButtonHandler.bind(this)}>{this.strings.removeButton}</button>
                                        </span>
                                        <span className={classes.EditButtonAlign}>
                                            <button className={classes.CancelButton} onClick={this.removeCancelBtnHandler.bind(this)}>{this.strings.cancelButton}</button>
                                        </span>
                                    </span>
                                     <div className={classes.dividerLine} />
                            </span>:null}
                        </div>
                    :
                    contactType === 'email' ?
                        <div className={classes.sceTextBoxData}>
                            <SetUpEmailDropdown
                                    triggerOnClick={() => this.onContactDrawerToggleHandler('email')}
                                    onModifyCustomerPreference={(deviceType, value, maskedValue)=>this.props.onModifyCustomerPreference(deviceType, value, maskedValue, contactMethodIndex)}
                                    id={'email'}
                                    dropdownDiffererentiator={this.props.dropdownDiffererentiator}
                                    onDoneEnabledButton={this.props.onDoneEnabledButton}
                                    selectedValue={addContactValue[contactMethodIndex]}
                                    onSelectDropDown={(e) => this.onSelectDropDown(e, contactMethodIndex)}
                                    dropDownData={this.props.dropDownData}
                                    inputButtonText={this.strings.saveBtnName}
                                    addContactValueArr={this.props.addContactValueArr}
                                />
                        </div>
                        :
                        contactType === 'voice' ?
                            <div className={classes.sceTextBoxData}>
                                <SetUpVoiceDropdown
                                    triggerOnClick={() => this.onContactDrawerToggleHandler('voice')}
                                    onModifyCustomerPreference={(deviceType, value, maskedValue)=>this.props.onModifyCustomerPreference(deviceType, value, maskedValue, contactMethodIndex)}
                                    id={'voice'}
                                    dropdownDiffererentiator={this.props.dropdownDiffererentiator}
                                    onDoneEnabledButton={this.props.onDoneEnabledButton}
                                    selectedValue={NotificationHelper.formatPhoneNumWithStar(addContactValue[contactMethodIndex])}
                                    onSelectDropDown={(e) => this.onSelectDropDown(e, contactMethodIndex)}
                                    isSameValueError={this.props.isSameValueSelectError[contactMethodIndex]}
                                    dropDownData={this.props.dropDownData}
                                    inputButtonText={this.strings.saveBtnName}
                                    addContactEncValueArr={this.props.addContactEncValueArr}
                               />
                            </div>
                            :
                            <div className={classes.sceTextBoxData}>
                                <SetUpTextDropdown
                                    triggerOnClick={() => this.onContactDrawerToggleHandler('text')}
                                    onModifyCustomerPreference={(deviceType, value, maskedValue)=>this.props.onModifyCustomerPreference(deviceType, value, maskedValue, contactMethodIndex)}
                                    id={'text'}
                                    dropdownDiffererentiator={this.props.dropdownDiffererentiator}
                                    onDoneEnabledButton={this.props.onDoneEnabledButton}
                                    selectedValue={NotificationHelper.formatPhoneNumWithStar(addContactValue[contactMethodIndex])}
                                    onSelectDropDown={(e) => this.onSelectDropDown(e, contactMethodIndex)}
                                    isSameValueError={this.props.isSameValueSelectError[contactMethodIndex]}
                                    dropDownData={this.props.dropDownData}
                                    inputButtonText={this.strings.saveBtnName}
                                    addContactEncValueArr={this.props.addContactEncValueArr}
                                />
                            </div>
                }
            </div>
        );
    }
}

export default SelectedContactComponent;
